export var options = {
    verbose: true,
    commercialLicense: false,
    classNamePrefix: "amcharts-",
    autoSetClassName: false
};
//# sourceMappingURL=Options.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/.internal/core/Options.js
// module id = 52
// module chunks = 4